
import Vue from "vue";
import Component from "vue-class-component";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import LandingpageIllustration from "@/components/LandingpageIllustration.vue";
import {authService} from "@/AuthService";
import {settings} from "@/main";
import { profileSelectionRouteName } from "@/router"

@Component({
    components: {
        SectionPageHeading,
        LandingpageIllustration,
    },
})
export default class LoginOptions extends Vue {
    
    async beforeMount() {
        if (authService.isLoggedIn)
            await this.$router.push({ name: profileSelectionRouteName });
    }

    async goToLogin() {
        const profileSelectionLocation = this.$router.resolve({ name: profileSelectionRouteName});
        await authService.startAuthentication(profileSelectionLocation.href);
    }

    goToRegistration() {
        window.location.href = new URL("register", settings.jwtBearerAuthority).toString();
    }
}
